import { useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useResetPwd } from "./handlers";
import { regEmail, regNum } from "components/utils/comm";
import PhoneSelect from "components/select/phone/phone";
import { useBaseResetPwdParamContext } from "./context";
import "./rstpwd.scss";
import useAlertStore from "store/alert";
import Input from "components/input";

export default function ResetBasePwdPage() {
  const { t } = useTranslation();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const formRef = useRef<HTMLFormElement>(null);
  const txtRef = useRef<HTMLHeadingElement>(null);

  const { param, onChange, onSelect } = useBaseResetPwdParamContext();

  const { onSubmit } = useResetPwd();

  const Inner = () => {
    return (
      <div>
        아래 이메일 주소로 인증 메일이 발송됩니다.
        <h4 className="text-red-300 font-bold">[ {param.manEmlId} ]</h4>
        이메일 주소가 정확한지 다시 한번 확인해주세요.
      </div>
    );
  };

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("reset_pass_text_1");
    }
  }, [t]);

  return (
    <>
      <form
        id="rstpwd"
        ref={formRef}
        onSubmit={(e) => {
          e.preventDefault();
          const form = e.currentTarget;
          // 등록된 메일이 정확한지 다시 확인 필요
          onSetAlert({
            isOpen: true,
            innerHtml: (
              <>
                <Inner />
              </>
            ),
            cnclBtn: true,
            onSetConfirm: () => {
              onSubmit(form);
            },
          });
        }}
      >
        <h2>{t("reset_pass_default_inf")}</h2>
        <div className="pt-3">
          <h4 className="bg-gray-100 mb-6 p-4 dashed-b-1" ref={txtRef} />
        </div>
        <ul className="flex col gap-3">
          <li>
            <label htmlFor="">{t("lbl_en_sfnm_cmm")}</label>
            <Input
              type="text"
              name="manSurnm"
              required
              value={param.manSurnm}
              validatyTxt="영문성을 입력하에 주세요."
              onChange={(e) => onChange("manSurnm", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="">{t("lbl_en_fsnm_cmm")}</label>
            <Input
              name="manFstnm"
              required
              validatyTxt="영문이름을 입력하에 주세요."
              value={param.manFstnm}
              onChange={(e) => onChange("manFstnm", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="">{t("lbl_eml_id_cmm")}</label>
            <Input
              name="manEmlId"
              required
              value={param.manEmlId}
              onBlur={(e) => {
                const value = e.currentTarget.value;

                if (!regEmail.test(value)) {
                  e.currentTarget.style.color = "#ef233c";

                  return;
                }
                e.currentTarget.style.color = "#010101";
              }}
              validatyTxt="정확한 형식의 이메일을 작성하세요."
              onChange={(e) => onChange("manEmlId", e.currentTarget.value)}
            />
          </li>
          <li>
            <label htmlFor="">{t("lbl_phone_cmm")}</label>
            <div className="flex">
              <PhoneSelect
                styles="flex-1 bg-gray-100 min-w-[100px] border-0"
                ulStyles="top-[33px]"
                isReset={param.mobCntyCd === "+82"}
                onSelect={(mobCntyCd) => {
                  onSelect("mobCntyCd", "+" + mobCntyCd);
                }}
              />
              <Input
                name="mobNo"
                placeholder={t("place_phone_cmm")}
                required
                maxLength={12}
                value={param.mobNo}
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  if (!regNum.test(value)) {
                    e.currentTarget.value = "";
                    return;
                  }
                  if (regEmail.test(value)) {
                    e.currentTarget.style.color = "#010101";
                    return;
                  }
                  onChange("mobNo", value);
                }}
                validatyTxt="전화번호를 입력하여 주세요."
              />
            </div>
          </li>
        </ul>
        <div className="flex justify-center pt-[40px]">
          <button type="submit" className="btn bg-red-400">
            {t("btn_confirm")}
          </button>
        </div>
      </form>
    </>
  );
}
